import Head from 'next/head'

export default function SEO(): JSX.Element {
  return (
    <Head>
      <meta charSet="UTF-8" key="charset" />
      <link rel="icon" href="/favicon.ico" />
      <link rel="shortcut icon" type="image/png" href="/favicon.png" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
        key="viewport"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@unvest_io" />
      <meta name="twitter:creator" content="@unvest_io" />
      <meta
        name="twitter:image"
        content="https://illiquid.market/preview.jpeg"
      />

      <meta property="og:url" content="https://illiquid.market" />
      <meta
        property="og:image"
        content="https://illiquid.market/preview.jpeg"
      />
      <meta property="og:site_name" content="Illiquid Market" />
      <meta property="og:type" content="website" />
    </Head>
  )
}
